import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import {
	EditRestaurantContext,
	IEditRestaurantContext,
} from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import { AssignDevicesContext, IAssignDevicesContext } from '../devicesFormState/devicesFormContext';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const { changeTypeOfModalWindow, setDataForAssign, restaurantDevices } =
		useContext<IAssignDevicesContext>(AssignDevicesContext);
	const { restaurantId } = useContext<IEditRestaurantContext>(EditRestaurantContext);

	const handleSubmit = async () => {
		setDataForAssign({
			restaurantId,
			devices: restaurantDevices.items.map(({ id, isAssigned }) => ({ id, isAssigned })),
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={style.container}>
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" onClick={handleSubmit}>
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
